import * as types from '../constants/esignaturedetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  esignaturedetails: null,
  esignaturedetailsList: null,
  switchesignaturedetailsList: null
}

export function esignatureDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ESIGNATURE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_ESIGNATURE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        esignaturedetails: action.data
      };
    case types.FETCH_ESIGNATURE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // esignaturedetailsList:action.error
      };
    case types.FETCH_ESIGNATURE_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        esignaturedetailsList: null,
        esignaturedetails: null,
      };
    case types.FETCH_ESIGNATURE_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_ESIGNATURE_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        esignaturedetailsList: action.data
      };
    case types.FETCH_ESIGNATURE_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // esignaturedetailsList:action.error
      };
    case types.ADD_ESIGNATURE_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_ESIGNATURE_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.ADD_ESIGNATURE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_ESIGNATURE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    case types.UPDATE_FILE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.UPDATE_FILE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.UPDATE_FILE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/esignaturedetails.js